import NextImage from '@/features/Image';
import Link from 'next/link';

const BlogCard = ({ item }: { item: any }) => {
  return (
    <div className="blog__item">
      <div className="blog__item-inner">
        <div className="blog__thumb">
          <NextImage
            width={401}
            height={266}
            aspectRatio="3/2"
            src={item?.picture[0]?.url || '/images/beauty/beauty-home.png'}
            alt="blog Images"
          />
        </div>
        <div className="blog__content blog__content--style2">
          {item?.blog_categories?.length > 0 && (
            <div className="blog__meta">
              <Link href="/blogs">
                {item?.blog_categories?.map((item: any, i: number) => (
                  <span
                    key={item?.id || i}
                    className={`blog__meta-tag blog__meta-tag--style2`}
                  >
                    {item?.name}
                  </span>
                ))}
              </Link>
            </div>
          )}
          <h6>
            <Link href={`/blog/${item?.slug}` || ''}>{item?.title}</Link>
          </h6>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;
